import { default as doMallModel } from './mallModel';

export const sagaMallModel = doMallModel.sagas;
